import axios from "axios";

// ─── Components ───────────────────────────────────────────────
export const adminGetComponents = async () => {
  return axios.get("/api/admin/status/components");
};

export const adminCreateComponent = async (data) => {
  return axios.post("/api/admin/status/components", data);
};

export const adminUpdateComponent = async (id, data) => {
  return axios.patch(`/api/admin/status/components/${id}`, data);
};

export const adminDeleteComponent = async (id) => {
  return axios.delete(`/api/admin/status/components/${id}`);
};

// ─── Incidents ────────────────────────────────────────────────
export const adminGetIncidents = async (query) => {
  const url = axios.getUri({ url: "/api/admin/status/incidents", params: query });
  return axios.get(url);
};

export const adminGetIncident = async (id) => {
  return axios.get(`/api/admin/status/incidents/${id}`);
};

export const adminCreateIncident = async (data) => {
  return axios.post("/api/admin/status/incidents", data);
};

export const adminAddIncidentUpdate = async (id, data) => {
  return axios.post(`/api/admin/status/incidents/${id}/updates`, data);
};

export const adminDeleteIncident = async (id) => {
  return axios.delete(`/api/admin/status/incidents/${id}`);
};

// ─── Subscribers ──────────────────────────────────────────────
export const adminGetSubscribers = async (query) => {
  const url = axios.getUri({ url: "/api/admin/status/subscribers", params: query });
  return axios.get(url);
};

export const adminDeleteSubscriber = async (id) => {
  return axios.delete(`/api/admin/status/subscribers/${id}`);
};
